export const htmlClientCodeExample = 
`<html lang="en">
    <head>
        <title>SIX Streaming Market Data - WebSocket</title>
    </head>
    <body style="margin: 25px">
        <h1>SIX Streaming Market Data - WebSocket</h1>

        <div>
            <p><strong>
                A valid certificate is required to authenticate the APIs
                <br />
                <a href="https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html" target="_blank">Request a trial</a> or see how to <a href="https://web.apiportal.six-group.com/portal/bfi/documentation" target="_blank">install your certificate</a>
            </strong></p>
        </div>

        <label for="url">Target url: </label>
        <input id="url" type="text" placeholder="target url" value="wss://api.six-group.com/web/v2/websocket">

        <button id="connect" onclick="connect()">Connect</button>
        <button id="disconnect" onclick="disconnect()">Disconnect</button>

        <div id="status">Disconnected</div>

        <label for="messageField"></label>
        <textarea
            id="messageField"
            type="text"
            placeholder="type your command..."
            style="width: 100%; font-size: medium; resize: vertical;"
            rows="16">
subscription {
    startStream(scheme: TICKER_BC, ids: ["ABBN_4"]) {
        type
        requestedId
        requestedScheme
        high {
            value
            timestamp
        }
        low {
            value
            timestamp
        }
        bestBid {
            value
            size
            timestamp
        }
        bestAsk {
            value
            size
            timestamp
        }
    }
}
        </textarea>

        <input onclick="sendMsg();" value="send" type="button" style="margin-top: 10px">

        <div id="msg-box" style="width: 100%; height: 250px; background: #eee; overflow: scroll; margin-top: 10px"></div>
        <br />
        <label for="messages-no">Number of received messages: </label><div id="messages-no" style="display: inline-flex;"></div>

        <script>
            let status = document.getElementById("status");
            disconnected();

            function connected() {
                status.innerHTML = '<p style="color: green">connected</p>';
            }

            function disconnected() {
                status.innerHTML = '<p style="color: red">disconnected</p>';
            }

            let webSocket;

            function connect() {
                const webSocketEndpoint = document.getElementById("url").value;
                webSocket = new WebSocket(webSocketEndpoint);
                webSocket.onmessage = function (message) {
                    const msg = JSON.parse(message.data);
                    divMsg.innerHTML += "<strong> Server>: " + "<b>" + JSON.stringify(msg) + "</strong>";
                    divMsg.scrollTop = divMsg.scrollHeight;
                    countMessages = countMessages + 1;
                    messagesNo.innerHTML = countMessages;
                    const length = divMsg.innerHTML.length;
                    if (length > divMaxLength) {
                        divMsg.innerHTML = divMsg.innerHTML.substr(length - divMaxLength, length);
                    }
                };

                webSocket.onopen = function () {
                    console.log("connection opened");
                    connected();
                };

                webSocket.onclose = function (event) {
                    console.log("connection closed: " + JSON.stringify(event));
                    disconnected();
                };

                webSocket.onerror = function (event) {
                    console.log("error: " + JSON.stringify(event));
                };

                window.onclose = function () {
                    webSocket.close();
                }
            }

            function disconnect() {
                if (webSocket) {
                    webSocket.close();
                    disconnected();
                }
            }

            const msgField = document.getElementById("messageField");

            const divMsg = document.getElementById("msg-box");
            const messagesNo = document.getElementById("messages-no");

            function sendMsg() {
                const msgToSend = JSON.stringify({query: msgField.value});
                webSocket.send(msgToSend);
                divMsg.innerHTML += "<div style='color: green'>Client> " + msgToSend + "</div>";
                msgField.value = "";
            }

            const divMaxLength = 10000;
            let countMessages = 0;
            messagesNo.innerHTML = "<br /><strong>" + countMessages + "</strong>"

            document.getElementById("messageField").addEventListener("keyup", function (event) {
                event.preventDefault();
                if (event.key === "Enter") {
                    sendMsg();
                }
            });
        </script>
    </body>
</html>`
;

export const startStreamMessage = 
`subscription {
    startStream(scheme: TICKER_BC, ids: ["ABBN_4"]) {
        type
        requestedId
        requestedScheme
        high {
            value
            timestamp
        }
        low {
            value
            timestamp
        }
        bestBid {
            value
            size
            timestamp
        }
        bestAsk {
            value
            size
            timestamp
        }
    }
}`
;

export const updateMessages = 
`{"data":{"startStream":{"type":"START","requestedId":"ABBN_4","requestedScheme":"TICKER_BC","high":{"value":29.05,"unixTimestamp":1667981959.201569},"low":{"value":28.65,"unixTimestamp":1667980882.547938}}}}
{"data":{"startStream":{"type":"UPDATE","requestedId":"ABBN_4","requestedScheme":"TICKER_BC","high":{"value":28.77,"unixTimestamp":1667993376.222199}}}}
{"data":{"startStream":{"type":"UPDATE","requestedId":"ABBN_4","requestedScheme":"TICKER_BC","high":{"value":28.78,"unixTimestamp":1667993376.222199}}}}
...`
;

export const exampleQuery = 
`subscription {
    startStream(scheme: TICKER_BC, ids: ["ABBN_4"] streamId: "stream1") {
        type
        requestedId
        streamId
        requestedScheme
        lookup {
            listingName
            marketName
            listingCurrency
            listingStatus
        }
        open {
            value
            timestamp
            unixTimestamp
        }
        high {
            value
            timestamp
            unixTimestamp
        }
        low {
            value
            timestamp
            unixTimestamp
        }
        close {
            value
            timestamp
            unixTimestamp
        }
        last {
            value
            size
            timestamp
            unixTimestamp
        }
        bestBid {
            value
            size
            timestamp
            unixTimestamp
        }
        bestAsk {
            value
            size
            timestamp
            unixTimestamp
        }
        volume {
            value
            timestamp
            unixTimestamp
        }
        vwap {
            value
            timestamp
            unixTimestamp
        }
        openInterest {
            value
            timestamp
            unixTimestamp
        }
        settlementPrice {
            value
            timestamp
            unixTimestamp
        }  
    }
}`
;

export const exampleQueryResponse = 
`{"data":{"startStream":[{"type":"START","requestedId":"ABBN_4","streamId":"stream1","requestedScheme":"TICKER_BC","lookup":{"listingName":"ABB N","marketName":"SIX SX","listingCurrency":"CHF","listingStatus":"LISTED"},"open":{"value":32,"timestamp":"2023-05-08T09:01:52.000017+02:00","unixTimestamp":1683529312.000017},"high":{"value":32.3,"timestamp":"2023-05-08T14:09:55.820237+02:00","unixTimestamp":1683547795.820237},"low":{"value":31.9,"timestamp":"2023-05-08T09:02:08.473213+02:00","unixTimestamp":1683529328.473213},"close":{"value":32.22,"timestamp":"2023-05-08T15:07:00.652753+02:00","unixTimestamp":1683551220.652753},"last":{"value":32.22,"size":5,"timestamp":"2023-05-08T15:07:00.652753+02:00","unixTimestamp":1683551220.652753},"bestBid":{"value":32.21,"size":3691,"timestamp":"2023-05-08T15:07:01+02:00","unixTimestamp":1683551221},"bestAsk":{"value":32.23,"size":9768,"timestamp":"2023-05-08T15:07:01+02:00","unixTimestamp":1683551221},"volume":{"value":541760,"timestamp":"2023-05-08T15:07:00.652753+02:00","unixTimestamp":1683551220.652753},"vwap":{"value":32.103485,"timestamp":"2023-05-08T15:07:00.652753+02:00","unixTimestamp":1683551220.652753}}]}}
{"data":{"startStream":[{"type":"UPDATE","requestedId":"ABBN_4","streamId":"stream1","requestedScheme":"TICKER_BC","lookup":{"listingName":"ABB N","marketName":"SIX SX","listingCurrency":"CHF","listingStatus":"LISTED"},"bestBid":{"value":32.23,"size":4620,"timestamp":"2023-05-08T14:52:07+02:00","unixTimestamp":1683550327}}]}}
...`
;

export const closeStream = 
`mutation {
    closeStream(streamId: "stream1") {
        type
        streamId
    }
}`
;

export const closeStreamResponse = `{"data":{"closeStream":[{"type":"STOP","streamId":"stream1"}]}}`;

export const streamingURL = `wss://api.six-group.com/web/v2/websocket`;

export const startIntradayStream =
`subscription intradayStream {
    startIntradayStream(scheme: TICKER_BC, ids: "ABBN_4", intradayHistory: true, qualityOfService: DELAYED) {
        type
        requestedId
        requestedScheme
        historyComplete
        qualityOfService
        lookup {
            listingStatus
            listingCurrency
            listingShortName
        }
        trade {
            value
            size
            timestamp
            unixTimestamp
        }
    }
}`
;

export const startIntradayStreamUpdateMessage =
`{"data": {"startIntradayStream": [{"type": "START", "requestedId": "ABBN_4", "requestedScheme": "TICKER_BC", "qualityOfService": "DELAYED", "lookup": {"listingStatus": "LISTED", "listingCurrency": "CHF", "listingShortName": "ABB N"}, "trade": [{"value": 40.41, "size": 3, "timestamp": "2024-03-06T11:52:19.28821+01:00", "unixTimestamp": 1709722339.28821}]}]}}

{"data": {"startIntradayStream": [{"type": "HISTORY", "requestedId": "ABBN_4", "requestedScheme": "TICKER_BC", "historyComplete": false, "qualityOfService": "DELAYED","trade": [{"value": 40.32, "size": 18, "timestamp": "2024-03-06T09:00:45.000017+01:00", "unixTimestamp": 1709712045.000017}, {"value": 40.32, "size": 102, "timestamp": "2024-03-9:00:45.000017+01:00", "unixTimestamp": 1709712045.000017}, .....]}]}}

{"data": {"startIntradayStream": [{"type": "HISTORY", "requestedId": "ABBN_4", "requestedScheme": "TICKER_BC", "historyComplete": true, "qualityOfService": "DELAYED"]}]}}

{"data": {"startIntradayStream": [{"type": "UPDATE", "requestedId": "ABBN_4", "requestedScheme": "TICKER_BC", "bestAsk": {"value": 40.41, "size": 494, "timestamp": "2024-03-6T11:53:22.567383+01:00", "unixTimestamp": 1709722402.567383}}]}}
...`
;

// Streaming Market Data V3
export const streamingURLV3 = `wss://api.six-group.com/web/v3/websocket`;

export const startMarketDataStreamMessage =
`{
  "startMarketDataStream": {
    "streamId": "MarketDataStreamId-001",
    "scheme": "VALOR_BC",
    "id": "1222171_4",
    "qualityOfService": "REAL_TIME",
    "conflationType": "INTERVAL",
    "conflationPeriod": "PT2S",
    "fields": ["bestAsk", "bestBid", "tradingEvent"]
  }
}`
;

export const startMarketDataStreamMessageWithAllFields =
`{
  "startMarketDataStream": {
    "streamId": "MarketDataStreamId-002",
    "scheme": "VALOR_BC",
    "id": "1222171_4",
    "qualityOfService": "REAL_TIME",
    "fields": ["accruedInterest", "accruedInterestTPlusN", "accruedInterestTPlus3", "annualisedDividend", "auctionTheoreticalMatchingPrice", "aumShareClass", "averageDailyVolume1Week", "averageDailyVolume4Week", "averageDailyVolume12Week", "averageDailyVolume26Week", "averageDailyVolume52Week", "averageDailyVolumeMonthToDate", "averageDailyVolumePreviousMonth", "averageDailyVolumePreviousMonthToDate", "averageDailyVolumeTotalMonthToDate", "averageDailyVolumeTotalPreviousMonthToDate", "averagePrice1Week", "averagePrice4Week", "averagePrice12Week", "averagePrice52Week", "averagePriceMonthToDate", "basisPointValue", "bestAsk", "bestBid", "breakEvenPoint", "close", "close1Week", "close4Week", "close12Week", "close26Week", "close52Week", "closeYear", "consolidatedOpen", "consolidatedHigh", "consolidatedLow", "consolidatedClose", "consolidatedVolume", "convexity", "currentYield", "dailyAdjustmentFactor", "delta", "dividendYield", "duration", "excessTotalReturn", "fairValue", "finalSettlementFuture", "finalSettlementOption", "gamma", "gearing", "grossTotalReturn", "hedgeExcessReturn", "hedgeNetTotalReturn", "hedgePrice", "hedgeTotalReturn", "high", "high1Week", "high4Week", "high12Week", "high26Week", "high52Week", "highStaticLimit", "highYearToDate", "historicalVolatility30Days", "historicalVolatility90Days", "historicalVolatility180Days", "historicalVolatility250Days", "impliedVolatility", "indicatedAnnualDividend", "indicativeNetAssetValue", "intrinsicValue", "last", "lastAsk", "lastBid", "latestDividend", "low", "low1Week", "low4Week", "low12Week", "low26Week", "low52Week", "lowStaticLimit", "lowYearToDate", "marketCapitalisation", "mid", "modifiedDuration", "moneyness", "netAssetValue", "netChangeLast", "netChangeLastAuction", "netChangeReportedPrice", "netChangeValuationPrice", "netTotalReturn", "numberOfTrades", "omega", "open", "openInterest", "percentageChange1Week", "percentageChange4Week", "percentageChange12Week", "percentageChange26Week", "percentageChange52Week", "percentageChange3Year", "percentageChange5Year", "percentageChangeLast", "percentageChangeLastAuction", "percentageChangeReportedPrice", "percentageChangeValuationPrice", "percentageChangeYearToDate", "percentageSpreadBestBidAsk", "performanceYearToDate", "premium", "premiumPerAnnum", "priceEarningsRatioEstimated", "priceEarningsRatioReported", "referencePrice", "reportedPrice", "rho", "settlementPrice", "spreadBestBidAsk", "theta", "timeToMaturity", "timeValue", "totalAum", "totalExpenseRatio", "totalReturn", "trendIndicatorValuation", "turnover", "turnover1Week", "turnover4Week", "turnover12Week", "turnover26Week", "turnover52Week", "turnoverTotal", "valuationPrice", "valuationPrice1Week", "valuationPrice4Week", "valuationPrice12Week", "valuationPrice26Week", "valuationPrice52Week", "vega", "volume", "volume1Week", "volume4Week", "volume12Week", "volume26Week", "volume52Week", "volumeDerived", "volumeOffMarket", "volumeTotal", "volumeWeightedRate10thPercentile", "volumeWeightedRate25thPercentile", "volumeWeightedRate75thPercentile", "volumeWeightedRate90thPercentile", "vwap", "yieldToCall", "yieldToMaturity", "yieldToWorst", "tradingEvent"]
  }
}`
;

export const marketDataStreamStartAndUpdateMessages =
`{"type": "START", "streamId": "MarketDataStreamId-001", "qualityOfService": "REAL_TIME", "listingLookup": {"bc": 4, "listingShortName": "ABB N", "marketShortName": "SIX SX", "listingCurrency": "CHF", "listingStatus": "LISTED"}, "tradingEvent": {"category": "CONTINUOUS_TRADING", "unixTimestamp": 1789628508}, "bestAsk": {"value": 79.2, "size": 2486, "unixTimestamp": 1789633954.214476}, "bestBid": {"value": 79.16, "size": 1818, "unixTimestamp": 1789633953.965114}}

{"type": "UPDATE", "streamId": "MarketDataStreamId-001", "qualityOfService": "REAL_TIME", "bestBid": {"value": 79.16, "size": 681, "unixTimestamp": 1789633956.013663}, "bestAsk": {"value": 79.18, "size": 663, "unixTimestamp": 1789633956.017123}}`
;

export const stopStreamMessageV3 =
`{
  "stop": {
    "streamId": "MarketDataStreamId-001"
  }
}`
;

export const stopAcknowledgmentMessageV3 = `{"type": "STOP", "streamId": "MarketDataStreamId-001"}`;

export const errorMessageV3 = `{
  "type": "START",
  "streamId": "MarketDataStreamId-002",
  "error": {
    "messageCode": 4005,
    "message": "Invalid character(s) found for ids in '1222$171'.",
    "messageValues": {
      "parameter": "ids",
      "inputValue": "1222$171"
    }
    "category": "VALIDATION_ERROR",
    "type": "INVALID_INPUT"
  }
}`;
